export const isLocalhost = () => {
  return window.location.hostname === 'localhost';
};
